//  import axios from 'axios';
import axiosRequest from '@/utils/axios-default-request'

// 查询基本信息  post  param传参 sysUserId  登陆者id
let getSysInfoBasicsData = data =>
  axiosRequest.postBody('/clientinterface/getSysInfoBasicsData', data)

// 添加/编辑基本信息  post  param传参
/* {
userId:用户id
userName:用户名称
email:邮箱
phonenumber:手机号
sysInfoId:基本信息id
whNationalityId:国籍
personalProfile:个人简介
location:所在地
sysContactId:联系方式id
weiXin:微信
other:其他联系方式
} */
let addOrEditSysInfo = data =>
  axiosRequest.postBodyJson('/clientinterface/addOrEditSysInfo', data)

// 查询实名认证信息  post  param传参 sysUserId  登陆者id
let getSysSmrzData = data =>
  axiosRequest.postBody('/clientinterface/getSysSmrzData', data)

//添加/编辑实名认证信息
/*{
    "sysSmrzId": null,实名认证id
    "sysUserId": null,用户id
    "sysName": null,用户名称
    "sysIdCard": null,身份证件
    "sysFilename": null,文件名称
    "sysFileurl": null,文件路径
    "sysPassportName": null,护照名称
    "sysPassport": null,护照号码
    "sysPassportFilename": null,护照文件名称
    "sysPassportFileurl": null护照文件路径
}*/
let addOrEditSysSmrz = data =>
  axiosRequest.postBodyJson('/clientinterface/addOrEditSysSmrz', data)

// 获取简历详情
let getSupResumeData = data =>
  axiosRequest.postBody('/clientinterface/getSupResumeData', data)

// 获取概览页数据(全部) sysUserId  登陆者id
let getOverviewData = data =>
  axiosRequest.postBody('/clientinterface/getOverviewData', data)

// 上传头像
let upAvatar = data =>
  axiosRequest.postBodyJson('/clientinterface/upAvatar', data)

// 译员简历被查看推送提醒
let getResumeViewReminder = data =>
  axiosRequest.postBody('/clientinterface/getResumeViewReminder', data)

export default {
  getSysInfoBasicsData, //查询基本信息
  addOrEditSysInfo, // 添加/编辑基本信息
  getSysSmrzData, //查询实名认证信息
  addOrEditSysSmrz, //添加/编辑实名认证信息
  getSupResumeData, //获取简历详情
  getResumeViewReminder, //译员简历被查看推送提醒

  getOverviewData, //获取概览页全部数据
  upAvatar //上传头像
}
